import useGetPlatformInitialValues from './useGetPlatformInitialValues'

export default useGetPlatformInitialValues
